import Constant from '@/constant';

export default {
    [Constant.INITIALIZE_PROFILE]: (state, payload) => {
        state.profile = {
            name: "",
            registration_number: "",
            phone_number: "",
            height: "",
            weight: "",
            underlying_disease: ""
        }
    },
    [Constant.INITIALIZE_AGREEMENTS]: (state, payload) => {
        state.agreements = {
            agreement_personal_info: false,
            agreement_location_service: false,
            agreement_marketing: false,
            agreement_terms_condition_description: false
        }
    },
    [Constant.INITIALIZE_CARD_INFO]: (state, payload) => {
        state.card_info = {
            card_number: "",
            card_pw: "",
            card_ex_month: "",
            card_ex_year: "",
            card_nick_name: "",
            card_user_name: "",
            card_user_birth: ""
        }
    },
    [Constant.INITIALIZE_FILES]: (state, payload) => {
        state.files = {
            premedical_files: [],
            signature_file: null,
            delegation_docs_file: null, 
            id_card_file: null,
        }
    },
    [Constant.INITIALIZE_PROFILE_SPECIFY]: (state, payload) => {
        state.profile_specify = {
            name: '',
            registration_number: "",
        }
    },

    [Constant.FETCH_DIABETES_USER_PROFILES]: (state, payload) => {
        state.diabetes_profiles = payload.profiles
    },

    [Constant.INITALIZE_TEMP_CONTRACT]: (state, payload) => {
        state.temp_contract = {
            selectedType: -1,
            selectedRange: 1,
            curDate: '',
            endDate: '',
            allAgree: false,
            agreement_personal_info: false,
            agreement_terms_condition_description: false,
            name: '',
            birth: '',
            relation: -1,
            etcRelation: null,
            phoneNumber: '',
            signImageUrl: null,
            sign_file: null,
            id_card_file: null
        }
    },

    [Constant.SET_SHARED_PHARMACY]: (state, payload) => {
        state.sharedPharmacy = payload.pharmacy
    },

    [Constant.SEARCH_DIABETES_PHARMACY]: (state, payload) => {
        state.pharmacies = payload.pharmacies;
    },

    [Constant.INITIALIZE_CARDCHANGE_REQUEST]: (state, payload) => {
        state.cardchange_request_data = {
            barocare_client_id: process.env.BAROCARE_CLINET_ID,
            profile: {
                name: "",
                registration_number: "",
                address: null,
                detail_address: null,
                zip_code: null,
                address_nickname: null
            },
            card_info: {
                card_number: "",
                card_pw: "",
                card_ex_month: "",
                card_ex_year: "",
                card_nick_name: "",
                card_user_name: "",
                card_user_birth: ""
            }
        }
    },
    [Constant.SET_PHARMACY_MEDICINE_FILTER]: (state, payload) => {
        state.pharmacyMedicineFilter = Object.assign({}, state.pharmacyMedicineFilter, payload);
    },
    [Constant.SET_PHARMACY_USER_LOCATION]: (state, payload) => {
        state.pharmacyUserLocation = {
            latitude: payload.latitude,
            longitude: payload.longitude
        };
    },
    [Constant.SET_CHECKED_PHARMACY]: (state, payload) => {
        // 
        if(!state.checkPharmacyList.includes(payload.pharmacyId))
        {
            state.checkPharmacyList.push(payload.pharmacyId)
        }
    },
    [Constant.FETCH_DIABETES_SETTLEMENT]: (state, payload) => {
        state.diabetes_settlement.settlements = payload.settlements;
    },
    [Constant.FETCH_DIABETES_HISTORY]: (state, payload) => {
        state.diabetes_histories.total_count = payload.diabetes_histories.total_count;
        state.diabetes_histories.histories = payload.diabetes_histories.histories;
    },
    [Constant.FETCH_DIABETES_DOCUMENT]: (state, payload) => {
        state.diabetes_documents.prescriptions = payload.diabetes_documents.prescriptions;
        state.diabetes_documents.purchase_docs = payload.diabetes_documents.purchase_docs;
    },
    [Constant.INITALIZE_DIABETES_REQUEST]: (state, payload) => {

        state.new_request_data = {
            barocare_client_id: process.env.BAROCARE_CLINET_ID,
            staging_data_index: 0,
            profile: {
                name: "",
                registration_number: "",
                address: null,
                detail_address: null,
                zip_code: null,
                address_nickname: null
            },
            card_info: {
              card_number: "",
              card_pw: "",
              card_ex_month: "",
              card_ex_year: "",
              card_nick_name: "",
              card_user_name: "",
              card_user_birth: ""
            }
        }

        state.revisit_request_data = {        
            barocare_client_id: process.env.BAROCARE_CLINET_ID,
            staging_data_index: 0,
            profile: {
                name: "",
                registration_number: "",
                address: null,
                detail_address: null,
                zip_code: null,
                address_nickname: null
            },
            card_info: {
                card_number: "",
                card_pw: "",
                card_ex_month: "",
                card_ex_year: "",
                card_nick_name: "",
                card_user_name: "",
                card_user_birth: ""
            }
        }

        state.files = {
            premedical_files: [],
            signature_file: null,
            delegation_docs_file: null, 
            id_card_file: null,
        }

        state.status = {
            is_staging: false,
            is_duplicate: false,
            is_loading: false,
            profile_id: 0,
            duplicate_delegation_info: {
                is_delegated: false, 
                started_date: "", // 위임청구에 동의하지 않은 경우 null
                expired_date: "", // 위임청구에 동의하지 않은 경우 null
            },
            registerd_card_info: {
                card_name: "",
                card_nick_name: "",
                card_number: ""
            }
        }

        state.body = {
            barocare_client_id: process.env.BAROCARE_CLINET_ID,
            profile: {
                name: "",
                registration_number: "",
                address: null,
                detail_address: null,
                zip_code: null,
                address_nickname: null,
                address_description: null
            },
            // agreements: {
            //     agreement_marketing: false,
            //     agreement_sensitive_info: false,
            //     agreement_personal_info: false,
            //     agreement_terms_condition_description: false
            // },
            diabetes_type: null,         // 신규 추가
            agreement_personal_info: false,  // (개인정보 수집 및 동의)신규 추가
            agreement_sensitive_info: false, // (민감정보 수집 및 동의)신규 추가
            premedical_info: {
                phone_number: "",
                file_list: []
            },
            delegation_info: {
                agreement_delegate: true,
                agreement_personal_info: true,
                agreement_personal_identification_info: true,
                delegates_profile: null,
                // {
                //     type: "",
                //     name: "",
                //     birth: "",
                //     relationship: "",
                //     etc: "",
                //     phone_number: "",
                //     started_at: "2024-11-14T07:14:19.652Z",
                //     expired_at: "2024-11-14T07:14:19.652Z"
                // },
                file_list: null
                // {
                //     signature: {
                //         url: "",
                //         name: "",
                //         size: 0,
                //         type: ""
                //     },
                //     delegation_docs: {
                //         url: "",
                //         name: "",
                //         size: 0,
                //         type: ""
                //     },
                //     id_card: {
                //         url: "",
                //         name: "",
                //         size: 0,
                //         type: ""
                //     }
                // }
            }
        }
    },
    [Constant.INITIALIZE_DIABETES_VOC]: (state, payload) => {
        state.vocDiabetes = {
            id: 0,
            contents: '',
            likeCount: 0,
            yearCount: 0,
            createdAt: null,
            updatedAt: null,
            nickName: null,
            phoneNumber: null
        }
    },
    [Constant.FETCH_DIABETES_VOC_PAGE]: (state, payload) => {
        state.vocPage.pageno = payload.pageno - 1;
        state.vocPage.pagesize = payload.pagesize;
        state.vocPage.totalcount = payload.totalcount;
        state.vocPage.vocs = payload.vocs;
        state.vocPage.allCount = payload.allCount;
    },
    [Constant.SET_VOC_LOGIN_KAKAO_TOKEN]: (state, payload) => {
        state.vocLoginKakaoToken = payload.token;
    },
    //v2
    [Constant.FETCH_PROFILES]: (state, payload) => {
        state.diabetes_profiles = payload.diabetes_profiles
    },
    [Constant.FETCH_USAGE]: (state, payload) => {
        state.diabetes_histories.total_count = payload.diabetes_histories.total_count;
        state.diabetes_histories.histories = payload.diabetes_histories.usage;
    },
    [Constant.FETCH_DIABETES_DOCUMENT]: (state, payload) => {
        state.diabetes_documents.prescriptions = payload.diabetes_documents.prescriptions;
        state.diabetes_documents.purchase_docs = payload.diabetes_documents.purchase_docs;
    },
    [Constant.FETCH_YEAR_TAX]: (state, payload) => {
        state.diabetes_settlement.settlements = payload.settlements;
    },
    //v2
    [Constant.INITIALIZE_DRAFT_PROFILE]: (state, payload) => {
        state.draftProfile = {
            diabetes_type: "TYPE1",
            name: "",
            registration_number: "",
            phone_number: "",
            address: "",
            detail_address: "",
            zip_code: "",
            address_nickname: "",
            address_description: "",
            agreement_personal_info: true,
            agreement_sensitive_info: true
        }
    },
    [Constant.INITIALIZE_DELEGATE_WITH_ADDITION]: (state, payload) => {
        state.delegateWithAddition = {
            signature_file: null,
            delegation_docs_file: null,
            id_card_file: null,
            agreement_delegate: false,
            agreement_personal_info: false,
            agreement_personal_identification_info: false,
            started_at: '',
            expired_at: '',
            writer_type: 0,
            writer_name: '',
            writer_birth: '',
            writer_phone_number: '',
            writer_relationship: 0,
            writer_relationship_description: '',
            additional_info: {            
                is_injection_insulin: false,
                person_type: null,  // LOW_INCOME, NATIONAL_BASIC
                electrode_date: null,
                expendable_date: null,
                electrode_first: false,
                catheter_date: null           
            }
        }
    },
    [Constant.INITIALIZE_CARD_INFO]: (state, payload) => {
        state.cardInfo = {
            card_number: "",
            card_pw: "",
            card_ex_month: "",
            card_ex_year: "",
            card_nick_name: "",
            card_user_name: "",
            card_user_birth: ""
        }
    },
    [Constant.INITIALIZE_DELIVERY]: (state, payload) => {
        state.delivery = {
            address: "",
            detail_address: "",
            zip_code: "",
            address_nickname: "",
            address_description: ""
        }
    },
    [Constant.FETCH_PRE_DELEGATION_INFO]: (state, payload) => {
        state.pre_delegation_info.is_loading = payload.is_loading;
        state.pre_delegation_info.profile_id = payload.profile_id;
        state.pre_delegation_info.is_delegated = payload.pre_delegation_info.is_delegated;
        state.pre_delegation_info.started_at = payload.pre_delegation_info.started_at;
        state.pre_delegation_info.expired_at = payload.pre_delegation_info.expired_at;
    },
    [Constant.INITIALIZE_PROCESS_STATUS]: (store, payload) => {
        state.delivery = {
            address: "",
            detail_address: "",
            zip_code: "",
            address_nickname: "",
            address_description: ""
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js